import { render, staticRenderFns } from "./DefaultXrView.vue?vue&type=template&id=bad3a306&"
import script from "./DefaultXrView.vue?vue&type=script&lang=js&"
export * from "./DefaultXrView.vue?vue&type=script&lang=js&"
import style0 from "./DefaultXrView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports